import { useEffect } from "react";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaSquareXTwitter,
} from "react-icons/fa6";
import SocialSection from "../../components/SocialSection";
import classes from "./TeamMemberModal.module.css";

const SOCIAL_ICON_MAP = {
  facebook: { label: "Facebook", icon: <FaFacebookF /> },
  instagram: { label: "Instagram", icon: <FaInstagram /> },
  linkedin: { label: "LinkedIn", icon: <FaLinkedinIn /> },
  x: { label: "X", icon: <FaSquareXTwitter /> },
  twitter: { label: "X", icon: <FaSquareXTwitter /> },
};

function buildSocialLinks(social) {
  if (!Array.isArray(social)) return [];

  return social
    .map((item) => {
      const entry = SOCIAL_ICON_MAP[item.platform];
      if (!entry) return null;
      return { href: item.href, label: entry.label, icon: entry.icon };
    })
    .filter(Boolean);
}

export default function TeamMemberModal({ member, onClose }) {
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") onClose?.();
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [onClose]);

  if (!member) return null;

  const socialLinks = buildSocialLinks(member.social);

  return (
    <div className={classes.backdrop} onClick={onClose}>
      <div
        className={classes.modal}
        role="dialog"
        aria-modal="true"
        aria-label={member.name}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          className={classes.closeBtn}
          onClick={onClose}
          aria-label="Close"
        >
          ✕
        </button>

        <div className={classes.body}>
          <div className={classes.mediaCol}>
            <div className={classes.imageWrap}>
              <img src={member.img} alt={member.name} className={classes.image} />
            </div>

            <h2 className={classes.name}>{member.name}</h2>
            <p className={classes.designation}>{member.designation}</p>

            <div className={classes.infoGrid}>
              {member.designationShortForm && (
                <div>
                  <label>Role</label>
                  <p>{member.designationShortForm}</p>
                </div>
              )}
              {member.language && (
                <div>
                  <label>Language</label>
                  <p>{member.language}</p>
                </div>
              )}
              {member.phone && (
                <div>
                  <label>Phone</label>
                  <p>
                    <a href={`tel:${member.phone.replace(/[^\d+]/g, "")}`}>
                      {member.phone}
                    </a>
                  </p>
                </div>
              )}
              {member.email && (
                <div>
                  <label>Email</label>
                  <p>
                    <a href={`mailto:${member.email}`}>{member.email}</a>
                  </p>
                </div>
              )}
            </div>
          </div>

          <div className={classes.infoCol}>
            {member.about && (
              <section className={classes.section}>
                <h3 className={classes.sectionTitle}>About</h3>
                <p
                  className={classes.about}
                  dangerouslySetInnerHTML={{ __html: member.about }}
                />
              </section>
            )}

            {socialLinks.length > 0 && (
              <section className={classes.section}>
                <h3 className={classes.sectionTitle}>Connect</h3>
                <div className={classes.social}>
                  <SocialSection
                    links={socialLinks}
                    variant="light"
                    show={socialLinks.length > 0}
                  />
                </div>
              </section>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
